export interface TaxonomyCode {
  code: string;
  label: string;
}

export const STANDARD_TAXONOMY: readonly TaxonomyCode[] = [
  { code: 'EA', label: 'EA · Error algebraico' },
  { code: 'EC', label: 'EC · Error de cálculo' },
  { code: 'EP', label: 'EP · Error de planteamiento' },
  { code: 'ET', label: 'ET · Error teórico' },
  { code: 'UR-I', label: 'UR-I · No resuelto por idea' },
  { code: 'UR-B', label: 'UR-B · No resuelto por bloqueo' }
] as const;